export const getDescription = (content:string) : string => {
    let newDescription = content?.replace(/<span[\s\S]*?class="ql-size-small">[\s\S]*?<\/span>/, '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '');
    if (newDescription.length > 100) {
        newDescription = `${newDescription.slice(0, 100)}...`;
    }
    return newDescription;
};
